var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"a-btn",attrs:{"variant":"primary"}},[_vm._v("\n  資料を添付する\n  "),_vm._v(" "),(_vm.isComplete)?_c('b-button',{staticClass:"remove",attrs:{"variant":"outline-secondary"},on:{"click":function($event){$event.stopPropagation();return _vm.removeAllFiles($event)}}},[_vm._v("削除する")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a75fefd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/dropzone_problem.vue
// module id = null
// module chunks = 